import React from 'react';
import { CardIconProps } from './types';

function VisaIcon({ size = '2em' }: CardIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 132 43">
      <defs>
        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="prefix__visa">
          <stop stopColor="#241F5D" offset="0%" />
          <stop stopColor="#034EA1" offset="100%" />
        </linearGradient>
      </defs>
      <path
        d="M68.223 35.734c-.051 5.967 5.315 9.31 9.352 11.317 4.14 2.057 5.57 3.343 5.52 5.144-.052 2.777-3.323 4.012-6.389 4.063-5.366.103-8.483-1.44-10.936-2.623l-1.942 9.105c2.228 1.007 6.116 1.932 10.294 2.16h3.398c10.154-.577 16.715-5.985 16.715-14.146.05-10.956-15.025-11.573-14.923-16.46.051-1.492 1.431-3.086 4.549-3.498 1.532-.206 5.723-.36 10.527 1.852l1.89-8.796C93.725 22.926 90.403 22 86.315 22c-10.58 0-18.04 5.659-18.091 13.734zm46.044-12.962c-2.044 0-3.782 1.183-4.549 3.034L93.724 64.282h11.191l2.249-6.223h13.695l1.278 6.223H132l-8.585-41.51h-9.148zm1.533 11.213l3.22 15.586h-8.841l5.621-15.586zM54.68 22.772l-8.84 41.51h10.68l8.841-41.51h-10.68zm-15.79 0L27.8 51.012 23.303 26.99c-.51-2.675-2.606-4.218-4.906-4.218H.256L0 23.955c3.73.823 7.973 2.109 10.527 3.549 1.584.874 1.993 1.594 2.555 3.652l8.484 33.126h11.293l17.273-41.51H38.89z"
        transform="translate(0 -22)"
        fill="url(#prefix__visa)"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default VisaIcon;
